import { useEffect, useState } from "react"

const KEY = "onboarding-done-v1"

export function Onboarding() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (typeof window === "undefined") return
    if (!localStorage.getItem(KEY)) setShow(true)
  }, [])

  if (!show) return null
  const dismiss = () => {
    localStorage.setItem(KEY, "1")
    setShow(false)
  }
  return (
    <div className="onboard" role="dialog" aria-label="Jak to działa">
      <div className="card">
        <h2>automaty.de</h2>
        <p>
          Sprawdź status automatu kaucyjnego na mapie. Kliknij pinezkę, żeby zgłosić czy
          działa, albo dodaj nową pinezkę dla automatu, którego tu jeszcze nie ma.
        </p>
        <button onClick={dismiss}>Rozumiem</button>
      </div>
    </div>
  )
}
